import { SessionChange, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PROMOTIONS_NAMESPACE } from '../store/modules/promotions/promotions.store.js';
import { store } from '../store/index.js';
import { UserRolesUpdated } from '@gig/magic-common/dist/util/helpers/user';

var promotions = namespace(PROMOTIONS_NAMESPACE);
/**
 * Mixin responsible for fetching and providing promotions data
 * for given promo type
 */
var PromotionsMixin = /** @class */ (function (_super) {
    __extends(PromotionsMixin, _super);
    function PromotionsMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        return _this;
    }
    PromotionsMixin.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var language, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.isLoading = true;
                        language = this.magicConfig.language;
                        return [4 /*yield*/, Promise.all([
                                this.fetchCategories(language),
                                this.fetchEntries({
                                    type: this.type,
                                    lang: language,
                                    mobile: this.magicConfig.mobile,
                                }),
                            ])];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        this.__handleDataError(e_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PromotionsMixin.prototype.updateEntries = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.refreshEntries({
                                type: this.type,
                                lang: this.magicConfig.language,
                                mobile: this.magicConfig.mobile,
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        this.__handleDataError(e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emitted when there was an error loading promotions.
     * Provides error message
     */
    PromotionsMixin.prototype.__handleDataError = function (error) {
        return error;
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], PromotionsMixin.prototype, "type", void 0);
    __decorate([
        promotions.Getter('entries'),
        __metadata("design:type", void 0)
    ], PromotionsMixin.prototype, "promotions", void 0);
    __decorate([
        promotions.Getter('categories'),
        __metadata("design:type", void 0)
    ], PromotionsMixin.prototype, "categories", void 0);
    __decorate([
        promotions.Action('fetchCategories'),
        __metadata("design:type", Object)
    ], PromotionsMixin.prototype, "fetchCategories", void 0);
    __decorate([
        promotions.Action('fetchEntries'),
        __metadata("design:type", Object)
    ], PromotionsMixin.prototype, "fetchEntries", void 0);
    __decorate([
        promotions.Action('refreshEntries'),
        __metadata("design:type", Object)
    ], PromotionsMixin.prototype, "refreshEntries", void 0);
    __decorate([
        Watch('magicConfig.language', { immediate: true }),
        SessionChange(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], PromotionsMixin.prototype, "fetchData", null);
    __decorate([
        UserRolesUpdated(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], PromotionsMixin.prototype, "updateEntries", null);
    __decorate([
        Emit('error'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], PromotionsMixin.prototype, "__handleDataError", null);
    PromotionsMixin = __decorate([
        Component({
            store: store,
        })
    ], PromotionsMixin);
    return PromotionsMixin;
}(Mixins(MagicConfigMixin)));

export { PromotionsMixin };
